import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function ActivatePage() {
    const [message, setMessage] = useState('Trwa aktywacja konta...');
    const navigate = useNavigate();

    useEffect(() => {
        // Wyciągamy token z query stringa
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');

        if (!token) {
            // Brak tokena, błąd i szybkie przekierowanie
            setMessage('Brak tokena aktywacyjnego.');
            setTimeout(() => navigate('/login?activationStatus=error'), 1500);
            return;
        }

        // Wywołanie endpointa REST API WordPressa
        fetch(`https://geometryhustlers.pl/wp-json/wp/v2/users/activate?token=${token}`)
        .then(res => res.json())
        .then(data => {
            // Warianty statusów z API
            if (data.status === 'ok') {
                setMessage('Konto aktywowane! Przekierowuję do logowania...');
                setTimeout(() => navigate('/login?activationStatus=ok'), 1500);
            } else if (data.status === 'already') {
                setMessage('Twoje konto było już aktywowane. Przekierowuję do logowania...');
                setTimeout(() => navigate('/login?activationStatus=already'), 1500);
            } else {
                setMessage('Nieprawidłowy lub wygasły token aktywacyjny.');
                setTimeout(() => navigate('/login?activationStatus=error'), 1500);
            }
        })
        .catch(() => {
            setMessage('Błąd połączenia z serwerem.');
            setTimeout(() => navigate('/login?activationStatus=error'), 1500);
        });
    }, [navigate]);

    return (
        <div style={{minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <div>
        <h2>Aktywacja konta</h2>
        <p>{message}</p>
        </div>
        </div>
    );
}

export default ActivatePage;
